function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.7695 21.0917H2.2304C1.21517 21.0917 0.384521 20.26 0.384521 19.2434V14.9447C0.384521 13.9282 1.21517 13.0964 2.2304 13.0964H28.7695C29.7848 13.0964 30.6154 13.9282 30.6154 14.9447V19.2434C30.6154 20.26 29.7848 21.0917 28.7695 21.0917Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.0384 16.3956H4.36865V17.9743H11.0384V16.3956Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.05438 21.6569C7.05438 22.1837 6.62368 22.6149 6.0976 22.6149H4.2871C3.76103 22.6149 3.33032 22.1837 3.33032 21.6569",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.9343 21.6569C27.9343 22.1837 27.5036 22.6149 26.9775 22.6149H25.167C24.6409 22.6149 24.2102 22.1837 24.2102 21.6569",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.6683 13.0965L3.31173 1.0828C3.22251 0.616114 2.77334 0.311152 2.3088 0.400485C1.84425 0.489817 1.53814 0.938019 1.62582 1.4047L3.76243 13.0965",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.3315 13.0965L27.6881 1.0828C27.7773 0.616114 28.2265 0.311152 28.691 0.400485C29.1556 0.489817 29.4617 0.939559 29.3725 1.4047L27.2359 13.0965",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1363 18.3208C14.77 18.3208 15.2838 17.8064 15.2838 17.1718C15.2838 16.5373 14.77 16.0228 14.1363 16.0228C13.5025 16.0228 12.9888 16.5373 12.9888 17.1718C12.9888 17.8064 13.5025 18.3208 14.1363 18.3208Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9698 18.3208C18.6035 18.3208 19.1173 17.8064 19.1173 17.1718C19.1173 16.5373 18.6035 16.0228 17.9698 16.0228C17.336 16.0228 16.8223 16.5373 16.8223 17.1718C16.8223 17.8064 17.336 18.3208 17.9698 18.3208Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.4993 10.1038C16.1331 10.1038 16.6468 9.58936 16.6468 8.95478C16.6468 8.32021 16.1331 7.80579 15.4993 7.80579C14.8656 7.80579 14.3518 8.32021 14.3518 8.95478C14.3518 9.58936 14.8656 10.1038 15.4993 10.1038Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.498 7.40531C13.6073 7.14502 13.7672 6.91091 13.9641 6.71376C14.161 6.51661 14.3948 6.35797 14.6548 6.24707C14.9148 6.13772 15.2009 6.07611 15.5008 6.07611C15.8008 6.07611 16.0869 6.13772 16.3469 6.24707C16.6068 6.35643 16.8406 6.51661 17.0375 6.71376C17.2344 6.91091 17.3928 7.14502 17.5036 7.40531",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8181 6.51048C12.0196 6.03147 12.3134 5.60021 12.6749 5.23826C13.0364 4.87631 13.4671 4.58367 13.9455 4.38037C14.4239 4.1786 14.9484 4.06616 15.5006 4.06616C16.0529 4.06616 16.5774 4.1786 17.0558 4.38037C17.5342 4.58213 17.9649 4.87631 18.3264 5.23826C18.6879 5.60021 18.9801 6.03147 19.1832 6.51048",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4031 5.40459C10.6846 4.73768 11.0922 4.13853 11.5952 3.63334C12.0982 3.12815 12.6981 2.72154 13.3642 2.43968C14.0302 2.15782 14.7624 2.00226 15.53 2.00226C16.2976 2.00226 17.0298 2.15782 17.6958 2.43968C18.3619 2.72154 18.9603 3.12969 19.4648 3.63334C19.9678 4.13699 20.3754 4.73768 20.6569 5.40459",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8045 18.3208C22.4383 18.3208 22.952 17.8064 22.952 17.1718C22.952 16.5373 22.4383 16.0228 21.8045 16.0228C21.1707 16.0228 20.657 16.5373 20.657 17.1718C20.657 17.8064 21.1707 18.3208 21.8045 18.3208Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.6392 18.3208C26.273 18.3208 26.7867 17.8064 26.7867 17.1718C26.7867 16.5373 26.273 16.0228 25.6392 16.0228C25.0055 16.0228 24.4917 16.5373 24.4917 17.1718C24.4917 17.8064 25.0055 18.3208 25.6392 18.3208Z",
  stroke: "#DB5C0E",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 23,
  fill: "white"
})));

var SvgHubIcon = function SvgHubIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHubIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hubIcon.f1016384.svg";
export { ForwardRef as ReactComponent };